import { fetchCampaignProductsPreview } from './fetch-campaign-products-preview';
import { getMerchantCampaigns } from './get-campaigns';

export const MerchantCampaignsAPI = {
  getCampaigns: getMerchantCampaigns,
  fetchCampaignProductsPreview,
};

export type { SummaryProductInfo } from './types-get-single-campaigns-summary';
